import { CustomDatePicker } from '@/components';

import { NotificationOptionsProps } from './NotificationOptions.types';
import { NotificationCheckbox } from '../NotificationCheckbox';

export const NotificationOptions = ({
  sends,
  disabled,
  notificationDateTime,
  datePickerDisabled,
  hasOrderOptions,
  isCreateOrder,
  onSendChange,
  onNotificationDateChange
}: NotificationOptionsProps) => {
  if (!hasOrderOptions || !isCreateOrder) {
    return <></>;
  }

  const datePickerValue = notificationDateTime ? new Date(notificationDateTime) : null;

  return (
    <>
      <div className="upload-notifications-container">
        {/* Left column: SMS/EMAIL */}
        <div>
          <div className="upload-notifications-column">
            <NotificationCheckbox
              name="sendSMS"
              label="SMS"
              checked={sends.sendSMS}
              disabled={disabled}
              onSendChange={onSendChange}
            />
            <NotificationCheckbox
              name="sendMail"
              label="MAIL"
              checked={sends.sendMail}
              disabled={disabled}
              onSendChange={onSendChange}
            />
          </div>
        </div>

        {/* Right column: 1C/OKKO Core */}
        <div>
          <div className="upload-notifications-column">
            <NotificationCheckbox
              name="send1C"
              label="1C Back Office"
              checked={sends.send1C}
              disabled={disabled}
              onSendChange={onSendChange}
            />
            <NotificationCheckbox
              name="sendOkkoCore"
              label="OKKO Core (каса)"
              checked={sends.sendOkkoCore}
              disabled={disabled}
              onSendChange={onSendChange}
            />
          </div>
        </div>
      </div>

      <div className="upload-time-container">
        <span className="upload-time-label">Час сповіщення:</span>
        <div className="upload-time-inputs">
          <CustomDatePicker
            value={datePickerValue}
            format="dd.MM.yyyy HH:mm"
            showTime={true}
            timeFormat="HH:mm"
            includeSeconds={false}
            outputFormat="datetime-local"
            disabled={datePickerDisabled || disabled}
            onChange={onNotificationDateChange}
          />
        </div>
      </div>
    </>
  );
};
